import type { CSSProperties } from "react";
import { useDynamicHeight } from "@/Shared/Hooks/useDynamicHeight";

export interface DynamicSpacerProps {
  minHeight: number;
  maxHeight: number;
}

/**
 * Break glass — a spacer whose height interpolates with the viewport height:
 * min height below 800px, max height at 1024px and above.
 *
 * ui-core expresses spacing as `Stack`/`Grid` gap tokens, which are fixed
 * values — there's deliberately no token that means "somewhere between 24 and
 * 96px depending on how tall the window is". The height here is measured at
 * runtime, so it's a `CSSProperties` value routed through rather than
 * hardcoded presentation (same shape as `src/App/AppSiteMargin.tsx`).
 */
export default function DynamicSpacer(props: DynamicSpacerProps) {
  const elementHeight = useDynamicHeight(props.minHeight, props.maxHeight);
  const spacer: CSSProperties = { height: `${elementHeight}px` };

  return <div style={spacer}></div>;
}
